module.exports = __webpack_public_path__ + "img/bc_pic4.7e46a60d.png";